/*
 * @Author: Li, Yu Jia
 * @Date: 2020-02-27 16:38:57
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2020-02-27 16:41:02
 */

import Logo from './Logo';

export default Logo;
